export const FETCH_ERROR_STATUS = 'error/FETCH_ERROR_STATUS';
export const FETCH_ERROR = 'error/FETCH_ERROR';